import { forwardRef } from 'react';
import type { InputHTMLAttributes, ReactNode } from 'react';
import FormField from './FormField';
import Input from './Input';

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'value' | 'onChange'> & {
  label?: string;
  hint?: ReactNode;
  error?: ReactNode;
  required?: boolean;
  value: string;
  onChange: (value: string) => void;
};

const DatePicker = forwardRef<HTMLInputElement, Props>(
  ({ label, hint, error, required, id, name, value, onChange, ...props }, ref) => {
    return (
      <FormField label={label} htmlFor={id} hint={hint} error={error} required={required}>
        <Input
          ref={ref}
          id={id}
          name={name}
          type="date"
          value={value}
          onChange={(event) => onChange(event.target.value)}
          error={Boolean(error)}
          {...props}
        />
      </FormField>
    );
  }
);

DatePicker.displayName = 'DatePicker';

export default DatePicker;
